import React from 'react';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { Dac7ReportResponse } from '../../../common/api/dac7Service';
import { LOADING_STATUS } from '../../../common/constants';

type ImportWinTimeCardProps = {
  reports: Dac7ReportResponse[];
  selectedReportId: string;
  selectedFile: File | null;
  importStatus: LOADING_STATUS;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onSelectReportId: (value: string) => void;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onImport: () => void;
};

function ImportWinTimeCard({
  reports,
  selectedReportId,
  selectedFile,
  importStatus,
  fileInputRef,
  onSelectReportId,
  onFileChange,
  onImport,
}: ImportWinTimeCardProps) {
  return (
    <Card className="bg-white border shadow-none p-24 mb-24">
      <h5 className="mb-16">Tuo WinTime-tiedot</h5>
      <p className="text-muted mb-16">
        Tuo WinTime-järjestelmästä viety CSV-tiedosto DAC7-raporttiin. Tiedoston
        tulee sisältää sarakkeet: Toimittaja, Alkup.laskunro, Kohde, Varausnro,
        Maksupäivä, Summa, Y-tunnus. Alla esimerkki CSV -tiedostosta.
      </p>
      <pre>
        Toimittaja;Alkup.laskunro;Kohde;Varausnro;Maksupäivä;Summa;Y-tunnus
        <br />
        30000 ;1123147/1;17242;1120348;9.1.2025;-300,19;1651022-1
        <br />
        30001 ;1123149/1;17242;1120250;9.1.2025;-500,57;0848111-8
        <br />
        31030 ;1123150/1;17242;1120821;9.1.2025;-100,99;0924312-6
        <br />
        12665 ;1123158/1;17242;1220359;9.1.2025;-200,65;0931076-3
      </pre>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-16">
            <Form.Label>Valitse raportti</Form.Label>
            <Form.Select
              value={selectedReportId}
              onChange={e => onSelectReportId(e.target.value)}
            >
              <option value="">-- Valitse raportti --</option>
              {reports.map(report => (
                <option key={report.id} value={report.id}>
                  {report.reportingYear} - {report.messageRefId}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={5}>
          <Form.Group className="mb-16">
            <Form.Label>CSV-tiedosto</Form.Label>
            <Form.Control
              type="file"
              accept=".csv,.txt"
              onChange={onFileChange}
              ref={fileInputRef}
            />
          </Form.Group>
        </Col>
        <Col md={3} className="d-flex align-items-end">
          <Button
            variant="success"
            onClick={onImport}
            disabled={
              importStatus === LOADING_STATUS.LOADING ||
              !selectedReportId ||
              !selectedFile
            }
            className="mb-16 w-100"
          >
            {importStatus === LOADING_STATUS.LOADING ? (
              <>
                <Spinner size="sm" className="me-2" />
                Tuodaan...
              </>
            ) : (
              'Tuo tiedosto'
            )}
          </Button>
        </Col>
      </Row>
    </Card>
  );
}

export default ImportWinTimeCard;
